import React from 'react';

export default function Footer() {
  return (
    <footer>
      Source:{' '}
      <a href="https://www.abs.gov.au/census" target="_blank" rel="noreferrer">
        ABS
      </a>
    </footer>
  );
}
